import { ReactNode } from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { AcceptedMenuProduct } from '../../../../api';
import { formatCurrency } from 'utils';
import { InfoListCard, InfoListRow } from './InfoListCard';

interface Props {
  title: string;
  icon: ReactNode;
  products: AcceptedMenuProduct[];
}

export const AftermarketProductsCard = ({ title, icon, products }: Props) => {
  if (products.length === 0) return null;

  const total = products.reduce((sum, product) => sum + (product.retailCost ?? 0), 0);

  const rows: InfoListRow[] = products.map((product, index) => ({
    key: `${product.proposalProductId ?? product.aftermarketProduct?.productName ?? title}-${index}`,
    label: product.aftermarketProduct?.productName || product.title || '-',
    value: formatCurrency(product.retailCost ?? 0, true),
  }));

  return (
    <InfoListCard
      icon={icon}
      title={title}
      count={products.length}
      badge={
        <Box px={1} py={0.25} borderRadius={1} sx={{ bgcolor: theme => alpha(theme.palette.success.main, 0.1) }}>
          <Typography variant="body2" fontWeight={600} color="success.main">
            +{formatCurrency(total, true)}
          </Typography>
        </Box>
      }
      rows={rows}
    />
  );
};
